import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CsvImportService {

  constructor() { }

  importCSV(file: File, properties: string[], ignoreFirstLine: Boolean = true): Observable<Object[]> {

    const list = [];

    const reader = new FileReader();
    reader.readAsText(file);

    return new Observable((subscriber) => {

      reader.onload = (e) => {

        const fileText: string = reader.result as string;

        const regExp = new RegExp('\n');
        let rows = fileText.split(regExp).filter((row) => row.trim().length > 0);

        if (ignoreFirstLine) {
          rows = rows.slice(1);
        }

        for (let row = 0; row < rows.length; row++) {

          const newObject = {};
          // Split the text
          const currentRow = rows[row].replace('\r', '');
          const separatorRegEx = new RegExp(';|,');
          const values = currentRow.split(separatorRegEx);

          for (let i = 0; i < values.length && i < properties.length; i++) {
            const value = values[i];
            const key = properties[i];

            newObject[key] = value;
          }

          list.push(newObject);

        }

        // Finalize the observable
        subscriber.next(list);
        subscriber.complete();

      };


    });

  }

  importAllProperties(file: File): Observable<Object[]> {

    const list = [];

    const reader = new FileReader();
    reader.readAsText(file);

    return new Observable((subscriber) => {

      reader.onload = (e) => {

        const fileText: string = reader.result as string;

        const regExp = new RegExp('\n');
        const rows = fileText.split(regExp).filter((row) => row.trim().length > 0);

        if (rows.length === 0) {
          return [];
        }

        /**
         * Ignore both , or ; as excel sometimes uses it in some regions
         */
        const separatorRegEx = new RegExp(';|,');

        // The first row has the name of the properties to load
        const firstRow = rows.slice(0, 1)[0];
        console.log('first row: ' + JSON.stringify(firstRow, null, 4));
        const fileProperties = firstRow.replace('\r', '').split(separatorRegEx);
        const otherRows = rows.slice(1);
        console.log('number of rows: ' + otherRows.length);

        for (let row = 0; row < otherRows.length; row++) {

          console.log('going through rows');

          const newObject = {};

          // Split the text
          const values = otherRows[row].replace('\r', '').split(separatorRegEx);

          console.log(`value for row: ${row} values: ${values}`);

          for (let i = 0; i < values.length && i < fileProperties.length; i++) {

            const key = fileProperties[i];
            if (key !== '') {

              const value = values[i];
              newObject[key] = value;

              console.log(`key: ${key} value: ${value}`);

            }

          }

          list.push(newObject);

        }

        console.log('list is: ' + JSON.stringify(list, null, 4));

        // Finalize the observable
        subscriber.next(list);
        subscriber.complete();

      };


    });


  }

}
